import React, {useEffect, useRef, useState} from 'react';
import './onboard-credit-card-style.scss';
import Inputmask from "inputmask";
import parse from 'html-react-parser';
import logoVisibleShow from "./images/visible-show.svg";
import logoVisibleHide from "./images/visible-hide.svg";
import {useTranslation} from "react-i18next";
import {errorRandomReplace} from "../../../util/Validation";

const classNames = require('classnames');

const OnboardCreditCardCVC = (props) => {
    const {t} = useTranslation();

    const {
        error,
        value,
        onChange,
    } = props;
    const inputRef = useRef();

    const length = 4;
    const [mValue, setMValue] = useState(value != null ? value : "");
    const [mError, setMError] = useState(error);
    const [mHidden, setMHidden] = useState(false);

    useEffect(() => {
        setMError(error);
    }, [error]);

    useEffect(() => {
        setMValue(value != null ? value : "");
    }, [value]);

    const handleChange = (val) => {
        let text = val.target.value;
        text = text.replace(/[^0-9]/g, '');

        if (length !== undefined) {
            if (text.length > length) return;
        }

        if (error !== undefined) {
            setMError(null);
        }

        setMValue(text);
        if (onChange !== undefined)
            onChange(text);
    }

    useEffect(() => {
        setMask();
        if (mValue !== undefined && mValue != null && mValue.length > 0) {
            inputRef.current.value = parse(mValue);
        }
    }, [])

    const setMask = () => {
        Inputmask({
            mask: "9{3,4}",
            jitMasking: true
        }).mask(inputRef.current);
    }

    const setClassName = () => {
        return classNames({
            'onboard-credit-card-inp-error': mError,
            'onboard-credit-card-password-key': mHidden
        })
    }

    const handleHiddenBtn = () => {
        setMHidden(!mHidden);
    }

    const getShowHideButtonSrc = () => {
        return mHidden ? logoVisibleShow : logoVisibleHide;
    }

    return (
        <div className="onboard-credit-card-root w-60">
            <div className="onboard-credit-card-inp">
                <input ref={inputRef}
                       type="text"
                       inputMode="numeric"
                       pattern="[0-9]*"
                       placeholder="&nbsp;"
                       value={parse(mValue)}
                       onChange={(e) => handleChange(e)}
                       className={setClassName()}
                       id="cardCsc"
                       autoComplete="cc-csc"
                >
                </input>
                <div style={{width: '80%'}} className={"onboard-credit-card-label " + (mError ? 'onboard-credit-card-inp-error-label' : '')}>
                    {t('payment.credit_card.cvv')}
                </div>
                <span className="onboard-credit-card-focus-bg"></span>
                {mError && (<div className="onboard-credit-card-error-hint">{errorRandomReplace(mError)}</div>)}
                <span onClick={handleHiddenBtn} className={"onboard-credit-card-hidden-btn cursor"}>
                    <img alt="Show/Hide" src={getShowHideButtonSrc()}></img>
                </span>
            </div>
        </div>
    )
};

export default OnboardCreditCardCVC;
